
/* ============================== src/auth/AuthContext.js ============================== */
// src/auth/AuthContext.js
import { createContext } from "react";
export const AuthContext = createContext(null);
